import React from 'react';
import PropTypes from 'prop-types';

import {
    BB_RACING_WIDGET_TIMEFORM_LABEL_CLASS,
    BB_RACING_WIDGET_TIMEFORM_CLASS,
    BB_RACING_WIDGET_COMMENT_CLASS,
} from '../../constants';

const propTypes = {
    timeformEvents: PropTypes.object,
    eventId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
};

class TimeformTip extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: {},
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (!prevState.expanded.hasOwnProperty(nextProps.eventId)) {
            return {
                expanded: {
                    ...prevState.expanded,
                    [nextProps.eventId]: false,
                },
            };
        }

        return null;
    }

    lowerCase(name) {
        return name.replace(/\(.*?\)/, '').toLowerCase();
    }

    render() {
        const { timeformEvents, eventId } = this.props;

        if (!timeformEvents || !eventId) {
            return null;
        }

        const timeform = timeformEvents[eventId];
        if (!timeform) {
            return null;
        }

        const name = timeform.favourite_name;
        const description = timeform.analyst_verdict;

        let labelClassName = BB_RACING_WIDGET_TIMEFORM_LABEL_CLASS;

        if (this.state.expanded[eventId]) {
            labelClassName += ` ${BB_RACING_WIDGET_TIMEFORM_LABEL_CLASS}--expanded`;
        }

        return (
            <div className={BB_RACING_WIDGET_TIMEFORM_CLASS}>
                <div
                    className={labelClassName}
                    onClick={() => {
                        this.setState({
                            expanded: {
                                ...this.state.expanded,
                                [eventId]: !this.state.expanded[eventId],
                            },
                        });
                    }}
                >
                    <span className={`${BB_RACING_WIDGET_TIMEFORM_LABEL_CLASS}-title`}></span>
                    {this.lowerCase(name)}
                </div>
                {this.state.expanded[eventId] && (
                    <p className={BB_RACING_WIDGET_COMMENT_CLASS}>
                        {description}
                    </p>
                )}
            </div>
        );
    }
}

TimeformTip.propTypes = propTypes;

export default TimeformTip;
